import request from '../axios'
import { baseUrl } from '@/config/env'
import type { ApiResponse, GiftStock } from '@/views/mall/types'

/** API 通用参数（非 cart 函数使用） */
interface Params {
	[key: string]: unknown
}

/** 购物车商品参数 */
interface SetCartParams {
	mallProductId: string | number
	quantity: number
	storeId: string | number
}

/** 修改购物车数量参数 */
interface UpdateCartQuantityParams {
	id: string | number
	quantity: number | undefined
}

/**
 * 按商品 ID 列表查询当前门店的赠品及可用库存。
 * 使用串码选择模式 1，响应按主商品 ID 分组，保留同一赠品的各条库存记录顺序。
 */
export const getGiftListByProductIds = (params: {
	productIdList: (string | number)[]
	storeId: string | number
	stockSelectMode: 1
}): Promise<ApiResponse<Record<string, GiftStock[]>>> =>
	request({
		url: baseUrl + '/marking/api/mallProduct/getGiftListByProductIds/byStockSelectMode',
		method: 'post',
		data: params
	})

// 查商品详情
export const getProductDetail = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/detail',
		method: 'get',
		params: params
	})

// 新增购物车
export const setShoppingCart = (params: SetCartParams): Promise<ApiResponse> =>
	request({
		url: baseUrl + '/marking/api/shoppingCart/',
		method: 'post',
		data: params
	})

// 购物车列表
export const getShoppingCartList = (params?: Record<string, never>): Promise<ApiResponse> =>
	request({
		url: baseUrl + '/marking/api/shoppingCart/list',
		method: 'get',
		params: params ?? {},
		meta: { noBuId: true }
	})

// 批量删除购物车
export const delShoppingCartBatch = (params: (string | number)[]): Promise<ApiResponse> =>
	request({
		url: baseUrl + '/marking/api/shoppingCart/batch',
		method: 'delete',
		data: params
	})

// 修改购物车数量
export const updateShoppingCartQuantity = (params: UpdateCartQuantityParams): Promise<ApiResponse> =>
	request({
		url: baseUrl + '/marking/api/shoppingCart/quantity',
		method: 'put',
		data: params
	})

// 提交电商订单
export const submitOrders = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/order/eCom/submit',
		method: 'post',
		data: params
	})

// 我的订单
export const getMyOrder = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/order/myOrder',
		method: 'get',
		params: params
	})

// 订单详情
export const getOrderDetail = (params: Params) =>
	request({
		url: baseUrl + `/marking/api/order/${params.orderNo}`,
		method: 'get',
		params: params
	})

/** 查询当前电商商品配置的取货方式。 */
export const queryMallProductSalesMode = () =>
	request({
		url: baseUrl + '/marking/api/mallProduct/queryMallProductSalesMode',
		method: 'get'
	})

/** 批量查询 ERP 全局配置。 */
export const queryMallProductByEnums = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/queryByEnums',
		method: 'get',
		params: params
	})
